export default function getDataFromResponse(res: any) {
    try {
        return res.data.payload.data;
    } catch (e) {
        throw new Error('');
    }
}
